import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from '../services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class IsLoggedGuard  {
  constructor(
    private userService: UserService,
    private router: Router,
  ) {
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.userService.isLoggedIn().then((isLoggedIn) => {
      if (isLoggedIn) {
        return true;
      } else {
        this.router.navigate(['/connexion'], { queryParams: { returnUrl: state.url }});
        return false;
      }
    });
  }
}
